import { animateScroll } from "react-scroll";

export const scrollToBottom = (id) => {
  animateScroll.scrollToBottom({ containerId: id, duration: 0 });
};
export const scrollToBottomAnimated = (containerId, duration = 250) => {
  animateScroll.scrollToBottom({ containerId, duration });
};
export const scrollToTop = (containerId, duration = 250) => {
  animateScroll.scrollToTop();
};
